// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES5 which can result in a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
export var _DYN_TO_LOWER_CASE = "toLowerCase"; // Count: 17
export var _DYN_LENGTH = "length"; // Count: 137
export var _DYN_WARN_TO_CONSOLE = "warnToConsole"; // Count: 5
export var _DYN_THROW_INTERNAL = "throwInternal"; // Count: 9
export var _DYN_WATCH = "watch"; // Count: 7
export var _DYN_APPLY = "apply"; // Count: 7
export var _DYN_PUSH = "push"; // Count: 68
export var _DYN_SPLICE = "splice"; // Count: 15
export var _DYN_LOGGER = "logger"; // Count: 22
export var _DYN_CANCEL = "cancel"; // Count: 9
export var _DYN_INITIALIZE = "initialize"; // Count: 8
export var _DYN_IDENTIFIER = "identifier"; // Count: 9
export var _DYN_REMOVE_NOTIFICATION_0 = "removeNotificationListener"; // Count: 4
export var _DYN_ADD_NOTIFICATION_LIS1 = "addNotificationListener"; // Count: 4
export var _DYN_STRINGIFY = "stringify"; // Count: 10
export var _DYN_TRACE_ID = "traceId"; // Count: 19
export var _DYN_SPAN_ID = "spanId"; // Count: 22
export var _DYN_TRACE_FLAGS = "traceFlags"; // Count: 19
export var _DYN_IS_INITIALIZED = "isInitialized"; // Count: 11
export var _DYN_TRACE_HDR_MODE = "traceHdrMode"; // Count: 3
export var _DYN_GET_NOTIFY_MGR = "getNotifyMgr"; // Count: 5
export var _DYN_GET_PLUGIN = "getPlugin"; // Count: 5
export var _DYN_TRACK = "track"; // Count: 6
export var _DYN_NAME = "name"; // Count: 18
export var _DYN_I_KEY = "iKey"; // Count: 8
export var _DYN_TIME = "time"; // Count: 6
export var _DYN_PROCESS_NEXT = "processNext"; // Count: 15
export var _DYN_GET_PROCESS_TEL_CONT2 = "getProcessTelContext"; // Count: 2
export var _DYN_POLL_INTERNAL_LOGS = "pollInternalLogs"; // Count: 4
export var _DYN_VALUE = "value"; // Count: 32
export var _DYN_ENABLED = "enabled"; // Count: 6
export var _DYN_STOP_POLLING_INTERNA3 = "stopPollingInternalLogs"; // Count: 2
export var _DYN_UNLOAD = "unload"; // Count: 7
export var _DYN_ON_COMPLETE = "onComplete"; // Count: 4
export var _DYN_REASON = "reason"; // Count: 5
export var _DYN_FLUSH = "flush"; // Count: 5
export var _DYN_GET_TRACE_CTX = "getTraceCtx"; // Count: 4
export var _DYN_SET_TRACE_CTX = "setTraceCtx"; // Count: 3
export var _DYN_GET_ACTIVE_SPAN = "getActiveSpan"; // Count: 3
export var _DYN_SET_ACTIVE_SPAN = "setActiveSpan"; // Count: 5
export var _DYN_SPAN_CONTEXT = "spanContext"; // Count: 6
export var _DYN_PARENT_SPAN_CONTEXT = "parentSpanContext"; // Count: 4
export var _DYN_PARENT_SPAN_ID = "parentSpanId"; // Count: 3
export var _DYN_LOGGING_LEVEL_CONSOL4 = "loggingLevelConsole"; // Count: 2
export var _DYN_JOIN = "join"; // Count: 8
export var _DYN_CREATE_NEW = "createNew"; // Count: 7
export var _DYN_TEARDOWN = "teardown"; // Count: 9
export var _DYN_MESSAGE_ID = "messageId"; // Count: 4
export var _DYN_MESSAGE = "message"; // Count: 18
export var _DYN_ATTRIBUTE_COUNT_LIMI5 = "attributeCountLimit"; // Count: 3
export var _DYN_SUPPRESS_TRACING = "suppressTracing"; // Count: 5
export var _DYN_NOT_IMPLEMENTED = "notImplemented"; // Count: 3
export var _DYN_DIAG_LOG = "diagLog"; // Count: 9
export var _DYN__DO_TEARDOWN = "_doTeardown"; // Count: 5
export var _DYN_UPDATE = "update"; // Count: 5
export var _DYN_GET_NEXT = "getNext"; // Count: 10
export var _DYN_SET_NEXT_PLUGIN = "setNextPlugin"; // Count: 5
export var _DYN_SPLIT = "split"; // Count: 16
export var _DYN_IS_CHILD_EVT = "isChildEvt"; // Count: 3
export var _DYN_DATA = "data"; // Count: 17
export var _DYN_GET_CTX = "getCtx"; // Count: 6
export var _DYN_SET_CTX = "setCtx"; // Count: 10
export var _DYN_CONFIG = "config"; // Count: 9
export var _DYN_CALL = "call"; // Count: 6
export var _DYN_ITEMS_RECEIVED = "itemsReceived"; // Count: 3
export var _DYN_HEADERS = "headers"; // Count: 6
export var _DYN_URL_STRING = "urlString"; // Count: 5
export var _DYN_TIMEOUT = "timeout"; // Count: 6
export var _DYN_STATUS = "status"; // Count: 10
export var _DYN_REPLACE = "replace"; // Count: 12
export var _DYN_HOST = "host"; // Count: 11
export var _DYN_HAS_OWN_PROPERTY = "hasOwnProperty"; // Count: 3
export var _DYN_TOTAL_REQUEST = "totalRequest"; // Count: 4
export var _DYN_REQUEST_DURATION = "requestDuration"; // Count: 3
export var _DYN_FAILURE = "failure"; // Count: 4
export var _DYN_EXCEPTION = "exception"; // Count: 6
export var _DYN_THROTTLE = "throttle"; // Count: 4
export var _DYN_INDEX_OF = "indexOf"; // Count: 6
export var _DYN_TYPE = "type"; // Count: 18
export var _DYN_MATCH = "match"; // Count: 7
export var _DYN_SET_TRACE_FLAGS = "setTraceFlags"; // Count: 3
export var _DYN_PATHNAME = "pathname"; // Count: 6
export var _DYN_TRACE_STATE = "traceState"; // Count: 7
export var _DYN_COUNT = "count"; // Count: 6
export var _DYN_PRE_TRIGGER_DATE = "preTriggerDate"; // Count: 4
export var _DYN_GET_UTCDATE = "getUTCDate"; // Count: 3
export var _DYN_TIMINGS = "timings"; // Count: 4
export var _DYN_BASE_DATA = "baseData"; // Count: 5
export var _DYN_PROPERTIES = "properties"; // Count: 13
export var _DYN_USER_AGENT = "userAgent"; // Count: 4
export var _DYN_ATTRIBUTES = "attributes"; // Count: 6
export var _DYN_KIND = "kind"; // Count: 6
export var _DYN_START_TIME = "startTime"; // Count: 6
export var _DYN_DURATION = "duration"; // Count: 5
export var _DYN_TO_STRING = "toString"; // Count: 12
export var _DYN_PROCESS_TELEMETRY_ST6 = "processTelemetryStart"; // Count: 3
export var _DYN_HANDLE_FIELD = "handleField"; // Count: 3
export var _DYN_RM_SANITIZER = "rmSanitizer"; // Count: 3
export var _DYN_RM_FIELD_SANITIZER = "rmFieldSanitizer"; // Count: 3
export var _DYN_CAN_HANDLE = "canHandle"; // Count: 4
export var _DYN_HANDLER = "handler"; // Count: 5
export var _DYN_ERROR_HANDLERS = "errorHandlers"; // Count: 4
export var _DYN_EVT_NAME = "evtName"; // Count: 4
export var _DYN_CONCAT = "concat"; // Count: 5
export var _DYN_WARN = "warn"; // Count: 6
export var _DYN_INGESTIONENDPOINT = "ingestionendpoint"; // Count: 6
export var _DYN_CREATE_EVENT = "createEvent"; // Count: 4
export var _DYN_SUBSTRING = "substring"; // Count: 4
export var _DYN_GET_ALL_RESPONSE_HEA7 = "getAllResponseHeaders"; // Count: 2
export var _DYN_REMOVE_ITEM = "removeItem"; // Count: 3
export var _DYN_GET_ATTRIBUTE = "getAttribute"; // Count: 3
export var _DYN_CORRELATION_HEADER_E8 = "correlationHeaderExcludePatterns"; // Count: 2
export var _DYN_ENTRIES = "entries"; // Count: 5
export var _DYN_TRACE_CFG = "traceCfg"; // Count: 6
export var _DYN_MEASUREMENTS = "measurements"; // Count: 9
export var _DYN_SIZE_IN_BYTES = "sizeInBytes"; // Count: 4
export var _DYN_TYPE_NAME = "typeName"; // Count: 5
export var _DYN_EXCEPTIONS = "exceptions"; // Count: 5
export var _DYN_SEVERITY_LEVEL = "severityLevel"; // Count: 5
export var _DYN_PROBLEM_GROUP = "problemGroup"; // Count: 3
export var _DYN_PARSED_STACK = "parsedStack"; // Count: 6
export var _DYN_HAS_FULL_STACK = "hasFullStack"; // Count: 5
export var _DYN_ASSEMBLY = "assembly"; // Count: 4
export var _DYN_FILE_NAME = "fileName"; // Count: 9
export var _DYN_LINE = "line"; // Count: 6
export var _DYN_AI_DATA_CONTRACT = "aiDataContract"; // Count: 4
//# sourceMappingURL=__DynamicConstants.js.map